module.exports = __webpack_public_path__ + "static/media/Tick.db223d50.svg";